import { Alert, Button, LinearIconColored } from "@productlane/ui"

export const LinearCustomersDisabledWarning = () => {
	return (
		<Alert
			header="Please enable customer requests in Linear"
			variant="default"
			icon={LinearIconColored}
			className="-mx-4 mb-4 select-none"
		>
			<div className="mt-1 flex flex-col gap-3">
				<div>
					To fully use the Support Portal, please enable Linear Customer
					Requests.
				</div>
				<Button
					onClick={() =>
						window.open(
							"https://linear.app/settings/customers-requests",
							"_blank",
						)
					}
					className="w-min"
					variant="outline"
				>
					Open Linear settings
				</Button>
			</div>
		</Alert>
	)
}
